import script from "./CarouselView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselView.vue?vue&type=script&setup=true&lang=ts"

import "./CarouselView.vue?vue&type=style&index=0&id=34a21f5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a21f5d"]])

export default __exports__